import { Button } from "@chakra-ui/react";
import { InternalAddTemplateModal } from "features/internal/template/modals/InternalAddTemplateModal";
import { InternalTemplateImportModal } from "features/internal/template/modals/InternalTemplateImportModal";
import { useInternalEventTemplateTableDataRetrieveSuspense } from "gen/endpoints/internal/internal";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { PageTabBody } from "shared/components/layout/PageTabBody";
import { TableBox } from "shared/components/table/box/TableBox";
import { TableBoxBody } from "shared/components/table/box/TableBoxBody";
import { TableBoxHeader } from "shared/components/table/box/TableBoxHeader";
import { TableBoxTitle } from "shared/components/table/box/TableBoxTitle";
import { DataTable } from "shared/components/table/data/DataTable";
import { DataTableBoxActions } from "shared/components/table/data/DataTableBoxActions";
import { GetLinkInfoForRowFn } from "shared/components/table/data/DataTableTypes";
import { rootRoute } from "shared/navigation/Routes";
import { useBoolean } from "usehooks-ts";

export const InternalTemplateTab: React.FC = () => {
  const { t } = useTranslation(["internal"]);
  const { data: tableData } =
    useInternalEventTemplateTableDataRetrieveSuspense();

  const {
    value: isTemplateModalOpen,
    setTrue: openTemplateModal,
    setFalse: closeTemplateModal,
  } = useBoolean();

  const {
    value: isImportModalOpen,
    setTrue: openImportModal,
    setFalse: closeImportModal,
  } = useBoolean();

  const getLinkInfoForRow = useCallback<GetLinkInfoForRowFn>(({ row }) => {
    const metadata = row.data?.metadata;
    if (metadata?.type === "event_template") {
      return {
        type: "generic",
        to: rootRoute({})
          .internal({})
          .shadowTemplate({
            templateVersionId: metadata.event_template_version_id,
          })
          .template({}).$,
      };
    }
    return undefined;
  }, []);

  return (
    <PageTabBody>
      <TableBox>
        <TableBoxHeader>
          <TableBoxTitle>{t("internal:templates")}</TableBoxTitle>
          <DataTableBoxActions>
            <Button size="xs" onClick={openTemplateModal} isDisabled={true}>
              {t("internal:templateTabs.addTemplate.title")}
            </Button>
            <Button size="xs" onClick={openImportModal}>
              {t("internal:templateTabs.importTemplate.title")}
            </Button>
          </DataTableBoxActions>
        </TableBoxHeader>
        <TableBoxBody>
          <DataTable data={tableData} getLinkInfoForRow={getLinkInfoForRow} />
        </TableBoxBody>
      </TableBox>
      {isTemplateModalOpen && (
        <InternalAddTemplateModal onCloseComplete={closeTemplateModal} />
      )}
      {isImportModalOpen && (
        <InternalTemplateImportModal onCloseComplete={closeImportModal} />
      )}
    </PageTabBody>
  );
};
